module.exports = __webpack_public_path__ + "img/raspberry-pi-zero.588a9541.png";